import Styled from 'styled-components';
import logo from '../../../../static/img/balken/login_BALKEN.png';

const AuthWrapper = Styled.div`
  max-width: 500px;

  .balken-logo{
    margin-bottom: 2rem;
    width: 13rem;
  }

  .secondary-text{
    font-family: "Poppins", sans-serif;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    margin-top: 1.1rem;
    color: #153259;
    line-height: normal;
  }

  //Centra los links de la parte inferior
  .action-link{
    margin-block: 20px;
    display: flex;
    justify-content: center;
  }

  //Olvidaste tu contraseña?
  .forgot-password-text { 
    color: #000;
    text-align: center;
    font-weight: bold;
  }
`;

// Componentes estilizados
const Aside = Styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MainContent = Styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(rgba(255,255,255,0.9), rgba(255, 255, 255, 0.27)), 
              url(${logo}) center/cover no-repeat;

  @media (min-width: 768px) {
    background: none;
  }
`;

const Card = Styled.div`
  padding: 30px;
  border-radius: 12px;

   @media (max-width: 768px) {
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const DesktopLogo = Styled.img`
  max-width: 87vh;
`;

export { Aside, MainContent, Card, DesktopLogo, AuthWrapper };
